// extracted by mini-css-extract-plugin
export default {"container":"Edit_container__eMmz3","box":"Edit_box__48S+a","btn_box":"Edit_btn_box__1rpxc"};